import { HttpStatusCode } from 'enums/http-status-code';
import { rejectResponseByStatusCode } from 'api/interceptors/reject-response-by-status-code.interceptor';

export const rejectGracefullyNotFoundResponse = rejectResponseByStatusCode(
  HttpStatusCode.GRACEFULLY_NOT_FOUND,
);
